import * as React from 'react';
import { Helpers } from '@grandvisionhq/inventory';
import { isBoolean } from '@grandvisionhq/utils';
import { StockAndDelivery } from '../components/StockAndDelivery.js';
import { useCartSettings } from '../../../context/CartSettings/context.js';

const StockAndDeliveryContainer = ({ lineItem  })=>{
    const settings = useCartSettings();
    const deliveryResolver = settings.deliveryResolverFactory && settings.deliveryResolverFactory([
        lineItem
    ]);
    const availableQuantity = Helpers.getAvailableQuantity(lineItem.availability);
    return /*#__PURE__*/ React.createElement(StockAndDelivery, {
        hideStockAndDeliveryOnLineItem: settings.hideStockAndDeliveryOnLineItem,
        readOnly: settings.readOnly,
        availableQuantity: availableQuantity,
        availability: lineItem.availability,
        deliveryResolver: deliveryResolver,
        allowBackOrder: isBoolean(lineItem.allowBackOrder) ? lineItem.allowBackOrder : settings.allowBackOrder
    });
};

export { StockAndDeliveryContainer };
//# sourceMappingURL=StockAndDeliveryContainer.js.map
